import { render, staticRenderFns } from "./FormComboInput.vue?vue&type=template&id=5fec8ad9&scoped=true"
import script from "./FormComboInput.vue?vue&type=script&lang=ts"
export * from "./FormComboInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fec8ad9",
  null
  
)

export default component.exports